import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import type { Comic } from '@/mocks/comics';

interface FeaturedComicsProps {
  comics: Comic[];
  title: string;
  subtitle?: string;
  viewAllHref?: string;
}

export default function FeaturedComics({ comics, title, subtitle, viewAllHref }: FeaturedComicsProps) {
  return (
    <section className="py-12 md:py-16" data-product-shop="">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-foreground-500 mt-2">{subtitle}</p>
            )}
          </div>
          {viewAllHref && (
            <Link
              to={viewAllHref}
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {comics.map(comic => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}